"use client";
import { useState } from "react";
import { signIn } from "next-auth/react";
import { hooks, providers } from "@lib/client";
import logjs from "@metrojs/logjs";
const { useWebAppContext } = providers;

const log = new logjs("login/useLogin");

/** 当日ログイン失敗回数上限時（failure-check で canLogin: false）のアラート文言 */
const LOGIN_ATTEMPT_LIMIT_ALERT =
  "アカウントがロックされました<br/>解除される場合は事務局に連絡してください";

export function useLogin() {
  const { actions } = useWebAppContext();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [form, formProps] = hooks.useFormEx();

  const login = async (mode) => {
    try {
      setIsLoading(true);
      setError(null);

      const loginId = String(form.login_id ?? "").trim();
      if (loginId) {
        try {
          const res = await fetch("/api/login/failure-check", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ login_id: loginId }),
          });
          if (res.ok) {
            const status = await res.json();
            log.debug("loginFailureStatus", status);
            if (status.canLogin === false) {
              if (typeof actions?.showAlert === "function") {
                actions.showAlert(LOGIN_ATTEMPT_LIMIT_ALERT);
                setError(status.message || "ユーザ名かパスワードが違います");
              } else {
                setError(status.message || "ユーザ名かパスワードが違います");
              }
              return;
            }
          }
        } catch (err) {
          log.warn("login failure-check skipped", err);
        }
      }

      log.debug("ログイン処理開始", { form, mode });

      const result = await signIn("credentials", {
        login_id: form.login_id,
        password: form.password,
        mode: mode,
        redirect: false,
        callbackUrl: "/agreement", // 規約画面へ遷移
      });

      log.debug("ログイン結果", { result });

      if (result?.error) {
        // NextAuthのエラーメッセージを日本語に変換
        let errorMessage = "ログインに失敗しました";

        if (result.error === "CredentialsSignin") {
          errorMessage = "ユーザ名かパスワードが違います";
        } else if (result.error.includes("ユーザ名かパスワードが違います")) {
          errorMessage = result.error;
        }

        setError(errorMessage);
        return;
      }

      // ログイン成功時は規約画面へリダイレクト
      if (result?.ok) {
        window.location.href = "/agreement";
      }
    } catch (error) {
      log.error("ログインエラー", error);
      setError("ログインに失敗しました");
    } finally {
      setIsLoading(false);
    }
  };

  return [
    {
      ...form,
      error,
      isLoading,
    },
    {
      ...formProps,
      login,
    },
  ];
}
